import PropTypes from 'prop-types'
import React from 'react'
import { Preloader, AdditionalPreloader } from 'SRC/ui/Preloader'
import { connect } from 'react-redux'
import { getLoading, getElements, getQuery, getUserType, getPagination, getAdditionalLoading } from '../../../selectors'
import { Item } from '../Item'
import { Banner } from '../Banner'
import { ItemWithBrands } from '../ItemWithBrands'
import { isObjectEquals } from 'SRC/utils/Utils'
import { fetchUsers, setQuery } from '../../../actions'
import { globalOptions } from 'Core/constants'
import { getAppLoading, getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getFlattenCategories, getSpecifications } from 'SRC/modules/categories/selectors'
import config from 'SRC/config/config.yaml'

export class List extends React.Component {
  constructor(props) {
    super(props)

    this.ref = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll)
  }

  // componentDidUpdate(prevProps) {
  //   const { userType, jobSpecs } = this.props

  //   if (!isObjectEquals(this.props.query, prevProps.query)) {
  //     const params = this.getRequestParams()

  //     const paramsParsed = Object.keys(params).reduce((acc, curr) => {
  //       if (curr === 'specifications') {
  //         try {
  //           acc[curr] = JSON.parse(params[curr])
  //         } catch (err) {
  //           acc[curr] = params[curr]
  //         }
  //       } else {
  //         acc[curr] = params[curr]
  //       }

  //       return acc
  //     }, {})

  //     if (userType && userType.seo === 'poslodavac') {
  //       let jobTypeSpecification = null

  //       if (Array.isArray(jobSpecs)) {
  //         const findJobTypeSpecification = jobSpecs.find(spec => {
  //           return spec && spec.specification && spec.specification.title === 'Tip oglasa'
  //         })

  //         if (findJobTypeSpecification) jobTypeSpecification = findJobTypeSpecification
  //       }

  //       if (paramsParsed.specifications) {
  //         if (!paramsParsed.specifications.find(spec => spec.id === jobTypeSpecification.specification.id)) {
  //           paramsParsed.specifications.push({
  //             id: jobTypeSpecification.specification.id,
  //             value: 'Nudim posao'
  //           })
  //         }
  //       } else {
  //         paramsParsed.specifications = [{
  //           id: jobTypeSpecification.specification.id,
  //           value: 'Nudim posao'
  //         }]
  //       }
  //     }

  //     this.props.fetchUsers(paramsParsed, [])
  //   }
  // }

  handleScroll = () => {
    const { isLoading, isAdditionalLoading, users, pagination, fetchUsers } = this.props

    if (!isLoading && !isAdditionalLoading && users.length < pagination.totalCount) {
      const blockBorder = this.ref.current.scrollTop + this.ref.current.clientHeight
      if (this.ref.current.scrollHeight >= blockBorder) {
        const newPage = pagination.page + 1
        fetchUsers(this.getRequestParams(newPage), users, true)
      }
    }
  }

  getRequestParams = (page = 1) => {
    const { isMobileDevice, userType, query } = this.props

    const type = userType && userType.id
    const limit = globalOptions.usersCountPerPage

    const params = { ...query, page, limit }

    if (config.siteName !== 'Oglasi') {
      params.type = type
    }

    return params
  }

  hasBrandAddon = user => {
    return user.activeAddons.find(addon =>
      addon.action.label === config.userTypes.usersWithBrandsAddonActionLabel)
  }

  getItemClassName = (user, index) => {
    const classNames = ['user-item']
    const usersCount = this.props.users.length
    if (user.premium) classNames.push('pro-user')
    if (index === usersCount - 1 && usersCount % 3 > 0) {
      classNames.push('even')
    }
    return classNames.join(' ')
  }

  render() {
    const { isLoading, users, isAdditionalLoading, userType, isAppLoading, categorySeo } = this.props
    return (
      <div className='prodavnice-content' ref={this.ref}>
        {
          users.map((user, index) => {
            if (user.isBanner) return <Banner key={user.key} />

            if (this.hasBrandAddon(user) && userType.seo === config.userTypes.zastupnikSeo) {
              return <ItemWithBrands key={user.username} {...user} seo={user.type && user.type.seo} category={categorySeo} />
            }

            return (
              <Item
                key={user.username}
                {...user}
                userTypeSeo={user.type && user.type.seo}
                category={categorySeo}
                className={this.getItemClassName(user, index)}
              />
            )
          })
        }
        {!isAppLoading && isLoading ? <Preloader /> : null}
        {!isAppLoading && isAdditionalLoading ? <AdditionalPreloader /> : null}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const query = getQuery(state)
  let categorySeo = ''
  const categories = getFlattenCategories(state)
  if (query && query.category) {
    const categoryInFilter = categories.filter(item => item.id === Number(query.category))
    if (categoryInFilter.length) {
      categorySeo = categoryInFilter[0].seo
    }
  }
  return {
    isLoading: getLoading(state),
    users: getElements(state),
    query,
    userType: getUserType(state),
    pagination: getPagination(state),
    isAdditionalLoading: getAdditionalLoading(state),
    isAppLoading: getAppLoading(state),
    categorySeo,
    jobSpecs: getSpecifications(state),
    isMobileDevice: getIsMobileDevice(state)
  }
}

List.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isAdditionalLoading: PropTypes.bool.isRequired,
  isAppLoading: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    username: PropTypes.string.isRequired
  })).isRequired,
  query: PropTypes.shape(),
  fetchUsers: PropTypes.func.isRequired,
  userType: PropTypes.shape({
    id: PropTypes.number.isRequired,
    seo: PropTypes.string.isRequired
  }).isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,
  categorySeo: PropTypes.string.isRequired,
  jobSpecs: PropTypes.object.isRequired,
  isMobileDevice: PropTypes.string.isRequired
}

List.defaultProps = {
  isLoading: false,
  isAppLoading: false,
  isAdditionalLoading: false,
  users: [],
  categorySeo: ''
}

export default connect(mapStateToProps, { fetchUsers, setQuery })(List)
